<template>
  <v-row class="fill-height">
    <v-col>
      <v-sheet height="64">
        <v-toolbar flat color="white">
          <ButtonComp normalButton @click="dialog = true" textButton="Agregar" iconBut="fas fa-plus" classButton="mr-4" />

          <v-btn outlined class="mr-4" @click="setToday"> Hoy </v-btn>
          <v-btn fab text small @click="prev">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab text small @click="next">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu bottom right>
            <template v-slot:activator="{ on }">
              <v-btn outlined v-on="on">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Día</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Semana</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Mes</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = '4day'">
                <v-list-item-title>4 días</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="500">
        <v-calendar style="border: 1px solid #e7e7e7" ref="calendar" v-model="focus" color="primary" :events="events"
          :event-color="getEventColor" :event-margin-bottom="3" :now="today" :type="type" :value="selectedDate"
          @click:event="showEvent" @click:more="viewDay" @click:date="viewDay" @change="updateRange" :weekdays="diaHabil"
          locale="es" :short-weekdays="false"></v-calendar>

        <!-- Modal Agregar Evento -->
        <v-dialog v-model="dialog" max-width="300">
          <v-card>
            <v-card-title class="btn_otro">
              <label>Agregar evento</label>
              <v-spacer />
              <v-btn fab dark x-small class="btn_style3" @click="dialog = false"><v-icon dark>fa-times</v-icon></v-btn>
            </v-card-title>
            <v-container>
              <v-form @submit.prevent="addEvent">
                <textfieldComp type="text" textLabel="Agregar nombre" v-model="name" />
                <textfieldComp type="text" textLabel="Agregar un detalle" v-model="details" />

                <v-text-field type="date" label="Inicio del evento" v-model="start">
                </v-text-field>
                <v-text-field type="date" label="Fin del evento" v-model="end">
                </v-text-field>
                <v-text-field type="color" label="Color del evento" v-model="color">
                </v-text-field>
                <v-btn type="submit" color="primary" class="mr-4" @click.stop="dialog = false">
                  <v-icon left small>
                    fas fa-plus
                  </v-icon>
                  Agregar</v-btn>
              </v-form>
            </v-container>
          </v-card>
        </v-dialog>

        <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x>
          <v-card color="grey lighten-4" min-width="150px" heigth="200px" flat>
            <v-toolbar :color="selectedEvent.color" dark>
              <v-btn icon @click="deleteEvent(selectedEvent)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
              <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>

            <v-card-text>
              <v-form v-if="currentlyEditing !== selectedEvent.id">
                {{ selectedEvent.name }} - {{ selectedEvent.details }}
              </v-form>

              <v-form v-else>
                <v-text-field type="text" v-model="selectedEvent.name" label="Editar nombre">
                </v-text-field>

                <v-text-field v-model="selectedEvent.details" label="Editar detalles" type="text"></v-text-field>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-btn text v-if="currentlyEditing !== selectedEvent.id"
                @click.prevent="editEvent(selectedEvent.id)">Editar</v-btn>
              <v-btn text v-else @click.prevent="updateEvent(selectedEvent)">Guardar cambios</v-btn>
              <v-btn text color="secondary" @click="selectedOpen = false">
                Cancelar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import axios from "../../helpers/axios";
import { mapState } from "vuex";
import ButtonComp from '../../components/ComponentsEst/TableButtonComp.vue';
import textfieldComp from '../../components/ComponentsEst/textfieldComp.vue';

export default {
  props: {
    diaHabil: Array
  },
  components: {
    ButtonComp,
    textfieldComp
  },
  data: () => ({
    today: new Date().toISOString().substr(0, 10),
    focus: new Date().toISOString().substr(0, 10),
    type: "month",
    typeToLabel: {
      month: "Mes",
      week: "Week",
      day: "Day",
      "4day": "4 Days",
    },
    // weekday: [1, 2],
    start: null,
    end: null,
    selectedDate: null,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    name: null,
    details: null,
    color: "#1976D2",
    ano_lectivo: null,
    dialog: false,
    currentlyEditing: null,
    formEvent: {},
  }),
  computed: {
    ...mapState({ fechasFeriado: 'fechasFeriado' }),


    title() {
      const { start, end } = this;
      if (!start || !end) {
        return "";
      }

      const startMonth = this.monthFormatter(start);
      const endMonth = this.monthFormatter(end);
      const suffixMonth = startMonth === endMonth ? "" : endMonth;

      const startYear = start.year;
      const endYear = end.year;
      const suffixYear = startYear === endYear ? "" : endYear;

      const startDay = start.day + this.nth(start.day);
      const endDay = end.day + this.nth(end.day);

      switch (this.type) {
        case "month":
          return `${startMonth} ${startYear}`;
        case "week":
        case "4day":
          return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`;
        case "day":
          return `${startMonth} ${startDay} ${startYear}`;
      }
      return "";
    },
    monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: "UTC",
        month: "long",
      });
    },
  },
  mounted() {
    this.$refs.calendar.checkChange();
    this.getEvents();

  },
  methods: {


    async updateEvent(ev) {
      this.selectedEvent.id_colegio = parseInt(sessionStorage.getItem("id_colegio"))

      try {
        // eslint-disable-next-line no-unused-vars
        let response = await axios.put(`/administrativo/calendarioFeriado/${ev.id}/edit`, this.selectedEvent)
        this.getEvents()
        this.selectedOpen = false;
        this.currentlyEditing = null;
      } catch (error) {
        console.log(error);
      }
    },
    editEvent(id) {
      this.currentlyEditing = id;
    },

    async deleteEvent(ev) {
      try {
        await axios.delete(`/administrativo/calendarioFeriado/${ev.id}`)
        this.selectedOpen = false;
        this.getEvents();
      } catch (error) {
        console.log(error);
      }
    },
    async addEvent() {
      try {
        if (this.name && this.start && this.end) {
          this.formEvent = {
            id_colegio: parseInt(sessionStorage.getItem("id_colegio")),
            id_ano_lectivo: parseInt(sessionStorage.getItem("id_ano_lectivo")),
            name: this.name,
            details: this.details,
            start: this.start,
            end: this.end,
            color: this.color
          };


          let response = await axios.post(
            "/administrativo/calendarioFeriado",
            this.formEvent
          );
          console.log(response);


          this.$emit('eventoRecibido', this.formEvent)
          this.name = null;
          this.details = null;
          this.start = null;
          this.end = null;
          this.color = "#1976D2";
          this.getEvents();
        } else {
          console.log("Campos obligatorios");
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getEvents() {
      try {
        this.$store.dispatch('getFechasFeriado')
          .then(() => {
            const eventos = this.fechasFeriado.fechasFeriado.map(evento => ({
              name: evento.name,
              start: evento.start,
              end: evento.end,
              color: evento.color,
              details: evento.details,
              id: evento.id
            }));

            this.events = eventos;
          })

      } catch (error) {
        console.error('Error al obtener las fechas de feriado:', error);
      }

    },

    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = this.today;
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {

      this.start = start;
      this.end = end;
    },
    nth(d) {
      return d > 3 && d < 21
        ? "th"
        : ["th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th"][d % 10];
    },
  },
};
</script>